import { useCallback } from 'react'
import { UseLinkEditorProps } from './useLinkEditor.types'

const useLinkEditor = ({ editor, setShowModalLinkEditor, setUrl, url }: UseLinkEditorProps) => {
  const handleOpenModal = useCallback(() => {
    setUrl(editor?.getAttributes('link').href)
    setShowModalLinkEditor(true)
  }, [editor])

  const handleCloseModal = useCallback(() => {
    setShowModalLinkEditor(false)
    setUrl('')
  }, [])

  const saveLink = useCallback(() => {
    if (url) {
      editor?.chain().focus().extendMarkRange('link').setLink({ href: url, target: '_blank' }).run()
    } else {
      editor?.chain().focus().extendMarkRange('link').unsetLink().run()
    }
    editor?.commands.blur()
    handleCloseModal()
  }, [editor, url, handleCloseModal])

  const removeLink = useCallback(() => {
    editor?.chain().focus().extendMarkRange('link').unsetLink().run()
    handleCloseModal()
  }, [editor, handleCloseModal])

  return {
    handleOpenModal,
    handleCloseModal,
    saveLink,
    removeLink
  }
}

export default useLinkEditor
